import { useState } from "react";
import { Field, Form, Formik } from "formik";
import CustomErrorMessage from "../../components/CustomErrorMessage/CustomErrorMessage";
import * as Yup from "yup";
import styles from "./Login.module.css";
import { THEME } from "../../utils/THEME.tsx";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import api from "../../utils/axios/api.ts";

type LoginData = {
  email: string;
  password: string;
};


export default function Login() {
  const { t } = useTranslation();

  const [toggleClicado, setToggleClicado] = useState(false);
  const [showUnconfirmedModal, setShowUnconfirmedModal] = useState(false);

  const navigate = useNavigate();

  const LoginSchema = Yup.object().shape({
    email: Yup.string().email(t("invalidEmail")).required(t("required")),
    password: Yup.string()
      .required(t("required"))
      .min(3, "A senha deve ter pelo menos 8 caracteres"),
  });

  const handleToggle = () => {
    setToggleClicado(!toggleClicado);
  };

  const handleLogin = async (values: LoginData) => {
    try {
      const response = await api.post("/user/login", {
        email: values.email,
        password: values.password,
      });

      const token = response.data.token as string;
      const refreshToken = response.data.refreshToken as string;
      localStorage.clear();
      console.log(localStorage.getItem('storeId'))
      localStorage.setItem("token", token);
      localStorage.setItem("refresh_token", refreshToken);

      const userId = response.data.userId;
      localStorage.setItem("userId", userId);

      const user = await api.get(`/user/${userId}`);
      localStorage.setItem("role", user.data.role);
      
      if (user.data.role === "Client") {
        localStorage.setItem("clientId", user.data.client.id);
        console.log("oi");
      } else if (user.data.role === "Entrepeneur") {
        if (user.data.entrepeneur)
          localStorage.setItem("entrepeneurId", user.data.entrepeneur.id);

        if (user.data.entrepeneur.store.length > 0)
          localStorage.setItem("storeId", user.data.entrepeneur.store[0].id);
      }
      localStorage.removeItem("cep");
      await fetchEntrepreneur();
      navigate("/");
      window.location.reload();
    } catch (error: any) {
      const msg = error?.response?.data?.error ?? '';
      if (msg === 'Email not confirmed.') {
        setShowUnconfirmedModal(true);
      } else {
        alert("E-mail/Senha incorreto.");
      }
    }
  };

  const fetchEntrepreneur = async () => {
    try {
      const response = await api.get(`/chat/findFirstEntrepreneur`);
      const entrepreneurId = response.data.id;
      localStorage.setItem("entrepreneurIdChat", entrepreneurId);
      console.log("Entrepreneur ID salvo no localStorage:", entrepreneurId);
    } catch (error) {
      console.error("Erro ao buscar o ID do empreendedor:", error);
    }
  };

  return (
    <div className={styles.pageContainer}>
      {showUnconfirmedModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal}>
            <h2>E-mail não confirmado</h2>
            <p>Você precisa confirmar seu e-mail antes de fazer login. Verifique sua caixa de entrada e clique no link de ativação que enviamos.</p>
            <button className={styles.modalButton} onClick={() => setShowUnconfirmedModal(false)}>
              Entendido
            </button>
          </div>
        </div>
      )}
      <div className={styles.leftContainer}>
        <div className={styles.formContainer}>
          <div className={styles.cadastroContainer}>
            <p>{t("login.possuiCadastro")}</p>
            <Link className={styles.textLink} to={"/register/options"}>
              {t("login.fazerCadastro")}
            </Link>
          </div>
          <div className={styles.headerContainer}>
            <h1 className={styles.LoginHeader}> {t("login.login")}</h1>
          </div>
          <Formik
            initialValues={{
              email: "",
              password: "",
            }}
            validationSchema={LoginSchema}
            onSubmit={(values) => handleLogin(values)}
          >
            {({ errors, touched, handleSubmit }) => (
              <Form onSubmit={handleSubmit} className={styles.form}>
                <div className={styles.inputContainer}>
                  <label htmlFor="email">{t("login.email")}</label>
                  <Field name="email" type="email" />
                  {touched.email && errors.email && (
                    <CustomErrorMessage name="email" />
                  )}
                </div>
                <div className={styles.inputContainer}>
                  <label htmlFor="password">{t("login.senha")}</label>
                  <Field name="password" type="password" />
                  {touched.password && errors.password && (
                    <CustomErrorMessage name="password" />
                  )}
                </div>
                <button type="submit" className={styles.acessarButton}>
                  {t("login.acessar")}
                </button>
              </Form>
            )}
          </Formik>
          <div className={styles.lembrarEsqueciContainer}>
            <div className={styles.lembrarAcessoContainer}>
              <div
                onClick={handleToggle}
                className={styles.toggle}
                style={{
                  background: toggleClicado ? THEME.COLORS.PRIMARY : "#f2f2f2",
                }}
              ></div>
              <p> {t("login.lembrar")}</p>
            </div>
            <Link to="/esqueciasenha"> {t("login.esqueciSenha")}</Link>
          </div>
        </div>
      </div>
      <div className={styles.imageContainer} />
    </div>
  );
}
